/**
 * @module router/guards/staffTeamAuth
 * @description 스태프팀 전용 라우트 인증 가드 — '/mobile/staff-team/*' 경로에서
 * 미인증 상태의 접근을 스태프팀 로그인 페이지로 리다이렉트합니다.
 * 공개 라우트(meta.authorization === false — 로그인 페이지, 카카오 웹뷰 진입 배정 페이지)는 제외합니다.
 */

/**
 * 스태프팀 모바일 경로의 인증 여부를 검사합니다.
 * 인증되지 않은 경우 '/mobile/staff-team/login'으로 리다이렉트합니다.
 * 라우트 meta.authorization 이 false 면 공개 라우트로 보고 통과시킵니다
 * (SURINP-302 — 카카오 웹뷰 진입이 token 쿼리 없이도 로그인으로 튕기지 않도록).
 *
 * @param {import('vue-router').RouteLocationNormalized} to - 이동할 라우트
 * @param {import('vue-router').RouteLocationNormalized} from - 현재 라우트
 * @param {import('vue-router').NavigationGuardNext} next - 다음 라우트 진행 함수
 * @returns {boolean} 리다이렉트가 발생한 경우 true, 통과한 경우 false
 */
export const staffTeamAuthGuard = (to, from, next) => {
  const authToken = sessionStorage.getItem('authToken')
  const isStaffTeamPath = to.path.startsWith('/mobile/staff-team')
  const isPublicRoute = to.meta && to.meta.authorization === false

  if (isStaffTeamPath && !isPublicRoute && !authToken) {
    next({ path: '/mobile/staff-team/login' })
    return true
  }
  return false
}
